import { ReactNode } from 'react'
import { TopBar } from '../TopBar'
import { DevTopBar } from '../DevTopBar'
import { Sidebar } from './Sidebar'
import { SidebarProvider, useSidebar } from '../../context/SidebarContext'
import { useAuth } from '../../context/AuthContext'

interface AppLayoutProps {
  children: ReactNode
}

function LayoutContent({ children }: { children: ReactNode }) {
  const { collapsed } = useSidebar()
  const { user } = useAuth()

  // DevTopBar aparece apenas para masters em dev mode
  const hasDevBar = !import.meta.env.PROD && user?.user_master

  return (
    <div
      className={`min-h-screen bg-gray-50 flex flex-col transition-all duration-300 ${
        collapsed ? 'ml-20' : 'ml-64'
      } ${hasDevBar ? 'mt-10' : ''}`}
    >
      {/* TopBar - sticky no topo */}
      <TopBar />

      {/* Main Content */}
      <main className="flex-1">
        {children}
      </main>
    </div>
  )
}

export function AppLayout({ children }: AppLayoutProps) {
  return (
    <SidebarProvider>
      {/* Dev Top Bar - só aparece em dev para masters */}
      <DevTopBar />

      {/* Sidebar - fixed */}
      <Sidebar />

      {/* Content Area */}
      <LayoutContent>{children}</LayoutContent>
    </SidebarProvider>
  )
}
